import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const BusinessPartnersQuery = graphql(/* GraphQL */ `
  query businessPartners($searchText: String, $offset: Int!, $limit: Int!) {
    businessPartners(
      input: { searchText: $searchText, offset: $offset, limit: $limit }
    ) {
      ...BusinessPartnersPaged
    }
  }
`);
